import React, {Component} from "react";
import PageHeader from "../PageHeader";
import Menu from "../Menu";
import {Link} from "react-router-dom";
import api from "../../api";

export class Tips extends Component<any, any> {
    private copyTimeout: number | null;

    constructor(props: any) {
        super(props);
        window.scrollTo(0, 0);
        this.copyTimeout = null;
        this.state = {
            loading: true,
            error: '',
            connectingCompanyId: null,
            copiedCompanyId: null,
            dashboard: {
                phone: '',
                normalizedPhone: '',
                overallTotals: {
                    today: 0,
                    week: 0,
                    month: 0,
                    all: 0,
                    count: 0,
                },
                companies: [],
                recentTransactions: [],
            },
            activeQrCompany: null,
        };
    }

    componentDidMount() {
        this.loadDashboard();
    }

    componentWillUnmount() {
        if (this.copyTimeout) {
            window.clearTimeout(this.copyTimeout);
        }
    }

    loadDashboard = () => {
        this.setState({loading: true});

        api({
            url: '/widget/cloud-payments/dashboard',
            headers: {'Content-Type': 'application/json'},
            method: 'GET',
            withCredentials: true,
        }).then(result => {
            this.setState({
                loading: false,
                error: '',
                dashboard: result.data || this.state.dashboard,
            });
        }).catch(error => {
            const message = error && error.response && error.response.data && error.response.data.error
                ? error.response.data.error
                : 'Не удалось загрузить кабинет чаевых.';

            this.setState({
                loading: false,
                error: message,
            });
        });
    }

    connectCompany = (companyId: number) => {
        this.setState({connectingCompanyId: companyId, error: ''});

        api({
            url: '/widget/cloud-payments/company/' + companyId + '/connect',
            headers: {'Content-Type': 'application/json'},
            method: 'POST',
            withCredentials: true,
        }).then(() => {
            this.setState({connectingCompanyId: null});
            this.loadDashboard();
        }).catch(error => {
            const message = error && error.response && error.response.data && error.response.data.error
                ? error.response.data.error
                : 'Не удалось подключить чаевые.';

            this.setState({
                connectingCompanyId: null,
                error: message,
            });
        });
    }

    getQrImageUrl = (company: any, size = 220) => {
        if (company && company.qrApiUrl) {
            return company.qrApiUrl;
        }

        if (company && company.tipsLink) {
            return 'https://api.qrserver.com/v1/create-qr-code/?size=' + size + 'x' + size + '&data=' + encodeURIComponent(company.tipsLink);
        }

        return '';
    }

    downloadQr = (company: any) => {
        if (!company || !company.tipsLink) {
            return;
        }

        const qrUrl = this.getQrImageUrl(company, 700);
        if (!qrUrl) {
            return;
        }

        const link = document.createElement('a');
        const fileName = (company.address || company.title || 'tips').replace(/\s+/g, '_');
        link.href = qrUrl;
        link.download = 'QR_' + fileName + '.png';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    copyLink = async (company: any) => {
        if (!company || !company.tipsLink) {
            return;
        }

        try {
            const clipboard = (navigator as any).clipboard;
            if (clipboard && clipboard.writeText) {
                await clipboard.writeText(company.tipsLink);
            } else {
                this.fallbackCopy(company.tipsLink);
            }

            this.setState({copiedCompanyId: company.companyId});
            if (this.copyTimeout) {
                window.clearTimeout(this.copyTimeout);
            }
            this.copyTimeout = window.setTimeout(() => {
                this.setState({copiedCompanyId: null});
            }, 2000);
        } catch (error) {
            this.setState({error: 'Не удалось скопировать ссылку.'});
        }
    }

    fallbackCopy = (value: string) => {
        const textarea = document.createElement('textarea');
        textarea.value = value;
        textarea.setAttribute('readonly', 'readonly');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
    }

    openQr = (company: any) => {
        this.setState({activeQrCompany: company});
    }

    closeQr = () => {
        this.setState({activeQrCompany: null});
    }

    formatMoney = (amount: number) => {
        return new Intl.NumberFormat('ru-RU').format(amount || 0) + ' ₽';
    }

    renderTotals = (totals: any, compact = false) => {
        const className = compact ? 'tips-totals-grid tips-totals-grid--compact' : 'tips-totals-grid';

        return (
            <div className={className}>
                <div className="tips-total-card">
                    <span className="tips-total-label">Сегодня</span>
                    <strong>{this.formatMoney(totals.today)}</strong>
                </div>
                <div className="tips-total-card">
                    <span className="tips-total-label">Неделя</span>
                    <strong>{this.formatMoney(totals.week)}</strong>
                </div>
                <div className="tips-total-card">
                    <span className="tips-total-label">Месяц</span>
                    <strong>{this.formatMoney(totals.month)}</strong>
                </div>
                <div className="tips-total-card">
                    <span className="tips-total-label">Все время</span>
                    <strong>{this.formatMoney(totals.all)}</strong>
                </div>
            </div>
        );
    }

    renderRecentTransactions = (transactions: any[], emptyText: string, showCompany = false) => {
        if (!transactions || transactions.length === 0) {
            return <div className="tips-empty-card">{emptyText}</div>;
        }

        return (
            <div className="tips-transaction-list">
                {transactions.map((transaction: any) => (
                    <div className="tips-transaction-item" key={transaction.id + '_' + transaction.dateIso}>
                        <div className="tips-transaction-main">
                            <strong>{this.formatMoney(transaction.amount)}</strong>
                            <span>{transaction.dateTime}</span>
                        </div>
                        {showCompany ? (
                            <div className="tips-transaction-company">
                                {transaction.companyAddress || transaction.companyTitle}
                            </div>
                        ) : null}
                        {transaction.comment ? (
                            <div className="tips-transaction-comment">{transaction.comment}</div>
                        ) : null}
                    </div>
                ))}
            </div>
        );
    }

    renderCompanyCard = (company: any) => {
        const isConnecting = this.state.connectingCompanyId === company.companyId;
        const isCopied = this.state.copiedCompanyId === company.companyId;
        const actionLabel = company.status === 'pending' ? 'Повторить подключение' : 'Подключить чаевые';

        return (
            <div className="tips-company-card chio-card" key={company.companyId}>
                <div className="tips-company-head">
                    <div>
                        <div className="tips-company-address">{company.address || company.title}</div>
                        {company.title && company.title !== company.address ? (
                            <div className="tips-company-title">{company.title}</div>
                        ) : null}
                    </div>
                    <span className={'tips-status tips-status--' + company.status}>{company.statusLabel}</span>
                </div>

                <div className="tips-company-phone">
                    Номер для CloudTips: <strong>{company.phone || 'не указан'}</strong>
                </div>
                <div className="tips-company-message">{company.statusMessage}</div>

                {this.renderTotals(company.totals, true)}

                {company.isConnected ? (
                    <div className="tips-connected-block">
                        <div className="tips-link-box">
                            <span className="tips-link-label">Ссылка на чаевые</span>
                            <a href={company.tipsLink} target="_blank" rel="noopener noreferrer">{company.tipsLink}</a>
                        </div>

                        <div className="tips-company-actions">
                            <button type="button" className="tips-btn tips-btn--primary" onClick={() => this.openQr(company)}>
                                Показать QR
                            </button>
                            <button type="button" className="tips-btn tips-btn--secondary" onClick={() => this.copyLink(company)}>
                                {isCopied ? 'Скопировано' : 'Скопировать ссылку'}
                            </button>
                            <button type="button" className="tips-btn tips-btn--secondary" onClick={() => this.downloadQr(company)}>
                                Скачать QR
                            </button>
                        </div>

                        <div className="tips-qr-preview" onClick={() => this.openQr(company)}>
                            <img src={this.getQrImageUrl(company, 180)} alt={'QR для ' + (company.address || company.title)} />
                        </div>
                    </div>
                ) : (
                    <div className="tips-company-actions">
                        {company.canConnect ? (
                            <button
                                type="button"
                                className="tips-btn tips-btn--primary tips-btn--full"
                                onClick={() => this.connectCompany(company.companyId)}
                                disabled={isConnecting}
                            >
                                {isConnecting ? 'Подключаем...' : actionLabel}
                            </button>
                        ) : (
                            <Link to="/profile" className="tips-btn tips-btn--secondary tips-btn--full tips-btn-link">
                                Перейти в профиль
                            </Link>
                        )}
                    </div>
                )}

                <div className="tips-company-history">
                    <div className="tips-block-title">Последние чаевые по точке</div>
                    {this.renderRecentTransactions(company.recentTransactions, 'По этой точке пока нет чаевых.')}
                </div>
            </div>
        );
    }

    renderQrModal = () => {
        const company = this.state.activeQrCompany;
        if (!company || !company.tipsLink) {
            return null;
        }

        return (
            <div className="tips-modal-overlay" onClick={this.closeQr}>
                <div className="tips-modal" onClick={(event) => event.stopPropagation()}>
                    <button type="button" className="tips-modal-close" onClick={this.closeQr}>
                        Закрыть
                    </button>
                    <div className="tips-modal-title">{company.address || company.title}</div>
                    <img
                        className="tips-modal-qr"
                        src={this.getQrImageUrl(company, 420)}
                        alt={'QR для ' + (company.address || company.title)}
                    />
                    <div className="tips-company-actions">
                        <button type="button" className="tips-btn tips-btn--secondary" onClick={() => this.copyLink(company)}>
                            Скопировать ссылку
                        </button>
                        <button type="button" className="tips-btn tips-btn--primary" onClick={() => this.downloadQr(company)}>
                            Скачать QR
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const dashboard = this.state.dashboard;

        return (
            <div className='main news tips tips-dashboard'>
                <div className='content mx-w-content'>
                    <PageHeader pageTitle='Чаевые' backBtnUrl='/'/>
                    <div className='pt-header'></div>

                    <div className='ml-3 mr-3'>
                        <div className="tips-hero chio-card">
                            <div className="tips-hero-copy">
                                <h2 className='txt-large bold'>Чаевые с CloudTips</h2>
                                <p>
                                    Здесь можно подключить чаевые по каждой точке, открыть свою ссылку, показать QR клиенту
                                    и посмотреть последние поступления без перехода в админку.
                                </p>
                            </div>
                            <img className="tips-hero-image" src='/img/tips.png' alt='Чаевые'/>
                        </div>

                        <div className="tips-phone-banner">
                            <div className="tips-phone-banner__label">Номер для подключения</div>
                            <div className="tips-phone-banner__value">{dashboard.phone || 'Не указан'}</div>
                            <div className="tips-phone-banner__hint">
                                {dashboard.normalizedPhone
                                    ? 'CloudTips будет использовать номер ' + dashboard.normalizedPhone
                                    : 'Укажите корректный номер телефона в профиле, иначе подключение будет недоступно.'}
                            </div>
                        </div>

                        {this.state.error ? (
                            <div className="tips-alert tips-alert--error">{this.state.error}</div>
                        ) : null}

                        {this.state.loading ? (
                            <div className="tips-loading">Загружаем кабинет чаевых...</div>
                        ) : (
                            <>
                                <div className="tips-section-head">
                                    <h3>Сводка</h3>
                                    <span>{dashboard.overallTotals.count || 0} чаевых в истории</span>
                                </div>

                                {this.renderTotals(dashboard.overallTotals)}

                                <div className="tips-section-head">
                                    <h3>Мои точки</h3>
                                    <span>{(dashboard.companies || []).length} точек</span>
                                </div>

                                {dashboard.companies && dashboard.companies.length ? (
                                    dashboard.companies.map(this.renderCompanyCard)
                                ) : (
                                    <div className="tips-empty-card">
                                        Точки не найдены. Если это ошибка, проверьте привязку мастера к филиалам.
                                    </div>
                                )}

                                <div className="tips-section-head">
                                    <h3>Последние чаевые</h3>
                                    <span>Общая история по всем точкам</span>
                                </div>

                                {this.renderRecentTransactions(
                                    dashboard.recentTransactions,
                                    'Пока нет чаевых ни по одной точке.',
                                    true
                                )}
                            </>
                        )}
                    </div>
                </div>
                <Menu></Menu>
                {this.renderQrModal()}
            </div>
        )
    }
}

export default Tips;
